import React from "react";
import filledBtn from "../../images/RadioButton (1).svg";
import unFilledBtn from "../../images/RadioButton.svg";

const SubscriptionPlanBoxCompNew = ({ duration, price, isYearlyPlan, selectPlans, onClick, key }) => {
   const yearlyAmount = parseInt(price?.match(/[\d,]+/)[0].replace(/,/g, ""), 10);
   const monthlyAmount = yearlyAmount / 12;

   return (
      <div
         key={key}
         onClick={onClick}
         className={`pg-comman-prise-box-new-ui d-relative ${selectPlans ? "pg-white-prise-box-new-ui" : "pg-blue-prise-box-new-ui"
            }`}
      >
         {isYearlyPlan && <div className={`pg-best-deal-new-ui `}>BEST DEAL</div>}
         <div className="pg-radio-btn-box">
            <img src={selectPlans ? filledBtn : unFilledBtn} className="radio-button-select-plans" alt="radiobtn" />
            <div>
               <div className="duration">{duration}</div>
               <div style={{ marginTop: "10px" }}>
                  {price} {isYearlyPlan && <span style={{ fontWeight: "400" }}>{`($${monthlyAmount}/month)`}</span>}
               </div>
            </div>
         </div>
      </div>
   );
};

export default SubscriptionPlanBoxCompNew;
